<script lang="ts" setup>
import { reactive, watch, onMounted } from 'vue';
import BrandTextarea from '../../../components/BrandTextarea.vue';

import { QuestionModel } from '../types';
const props = defineProps<{
  question: QuestionModel;
  isChildQuestion?: boolean;
  multiQuestion?: boolean;
}>();
const emit = defineEmits(['answerChanged']);

const data = reactive({
  model: props.question,
  answer: '',
  spacing: 'mb-16',
  isChildQuestion: props.isChildQuestion,
});

onMounted(() => {
  if (props.isChildQuestion) data.spacing = 'mb-8';
  if (props.multiQuestion) data.spacing = 'mb-4';
});

watch(
  () => data.answer,
  () => {
    emit('answerChanged', {
      id: data.model.id,
      answer: data.answer,
    });
  },
);
</script>
<template>
  <div v-if="data.model" class="text-left w-full" :class="data.spacing">
    <p class="mb-2 font-bold whitespace-pre-line">
      {{ data.model.questionText }}
      <span v-if="data.model.mandatory && !data.isChildQuestion" class="text-red-500">*</span>
    </p>
    <label :for="data.model.id" class="block mb-4">{{ data.model.helperText }}</label>

    <BrandTextarea
      :id="data.model.id"
      rows="3"
      class="inlineErrorInput bg-gray-50"
      :placeholder="data.model.placeholderText"
      v-model="data.answer"
      maxlength="2000"
    />
  </div>
</template>
